import React from 'react';
import { SchemeItem } from './SchemeItem';
import { GlobalHotKeys } from 'react-hotkeys';

class Schemes extends React.Component {
  state = {
    displaySchemes: false,
  };
  /*callback = (childData) => {
        const { data } = this.props;
        if (this.props.data.inventory[childData.name]) {
            this.props.data.inventory[childData.name] = {
                value: data.inventory[childData.name].value + childData.result,
                weight: data.inventory[childData.name].weight + childData.weight * childData.result,
                baseWeight: childData.weight,
                basePrice: childData.price,
            };
        } else {
            this.props.data.inventory[childData.name] = {
                value: childData.result,
                weight: childData.weight * childData.result,
                baseWeight: childData.weight,
                basePrice: childData.price,
            }
        }
        if (childData.draggable === true) {
            this.props.data.inventory[childData.name].draggable = true;
            this.props.data.inventory[childData.name].properties = childData.properties;
            ++this.props.data.inventory[childData.name].properties.totalAmount;
        }
        data.weight.current = data.weight.current + childData.weight * childData.result;
        for (let i=0; i<childData.items.length; i++) {
            data.inventory[childData.items[i].name].value = data.inventory[childData.items[i].name].value - childData.items[i].amount;
            data.inventory[childData.items[i].name].weight = data.inventory[childData.items[i].name].weight - childData.items[i].amount * data.inventory[childData.items[i].name].baseWeight;
            data.weight.current = data.weight.current - childData.items[i].amount * data.inventory[childData.items[i].name].baseWeight
        }
        this.props.callback(this.props)
    };*/

  isAvailable = (item) => {
    const { inventory } = this.props.redux;
    let counter = 0;
    for (let i = 0; i < item.items.length; i++) {
      if (inventory[item.items[i].name] !== undefined) {
        if (inventory[item.items[i].name].value >= item.items[i].amount) {
          ++counter;
        }
      }
    }
    return counter === item.items.length;
  };

  toggleSchemes = (event) => {
    event.preventDefault();
    if (this.state.displaySchemes) {
      this.setState({
        displaySchemes: false,
      });
    } else {
      this.setState({
        displaySchemes: true,
      });
    }
  };

  render() {
    const { schemes } = this.props.redux;
    const keyMap = {
      TOGGLE_SCHEMES: ['q'],
    };
    const handlers = {
      TOGGLE_SCHEMES: this.toggleSchemes,
    };
    let schemesTemplate;
    schemesTemplate = schemes.map(
      function (item, index) {
        return (
          <React.Fragment key={index}>
            <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
            <React.Fragment>
              {item.researched ? (
                <SchemeItem
                  key={index}
                  available={this.isAvailable(item)}
                  data={item}
                  redux={this.props.redux}
                />
              ) : (
                ''
              )}
            </React.Fragment>
          </React.Fragment>
        );
      }.bind(this)
    );
    return (
      <div className={this.state.displaySchemes ? 'schemes open' : 'schemes'}>
        <div className="schemes__container">{schemesTemplate}</div>
      </div>
    );
  }
}

export { Schemes };
